/**
 * 复制内容到剪贴板
 * @param {string} [text] - 无需id，直接复制的文本
 * @returns {void}
 */
export const copyContent = (text: string | number) => {
  if (typeof text === 'undefined') {
    throw new Error('text is required')
  }
  const val = String(text)
  const len = val.length
  // fixed：修复safari不生效的问题
  const createElement = (value: string) => {
    const isRTL = document.documentElement.getAttribute('dir') === 'rtl'
    const fakeElement = document.createElement('textarea')
    // Prevent zooming on iOS
    fakeElement.style.fontSize = '12pt'
    // Reset box model
    fakeElement.style.border = '0'
    fakeElement.style.padding = '0'
    fakeElement.style.margin = '0'
    // Move element out of screen horizontally
    fakeElement.style.position = 'absolute'
    fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px'
    // Move element to the same position vertically
    const yPosition = window.pageYOffset || document.documentElement.scrollTop
    fakeElement.style.top = `${yPosition}px`

    fakeElement.setAttribute('readonly', '')
    fakeElement.value = value
    return fakeElement
  }

  const fakeElement = createElement(val)
  document.body.appendChild(fakeElement)
  fakeElement.select()
  fakeElement.setSelectionRange(0, len)
  document.execCommand('copy')
  fakeElement.remove()
}
